import { SigninContext } from "pages/signin/SigninContext";
import React, { useContext, useEffect } from "react";

export const SystemError: React.FC = () => {
    const { setSuccess } = useContext(SigninContext);
    useEffect(() => {
        // 共通エラーページから離れた際に、ログイン画面に遷移する
        return () => {
            setSuccess(false);
        };
    }, [setSuccess]);
    return (
        <section className="page">
            <div
                style={{
                    height: "500px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <h2 style={{ fontSize: "24px" }}>
                    <div>画面の処理中にエラーが発生しました。</div>
                    <div>ご迷惑をおかけしております。</div>
                </h2>
            </div>
        </section>
    );
};
